import React from 'react';

import ClientApplication from './app';
import { LoginCheck } from './loginCheck';

export const CredentialChecker = (routes) => {
    return (
        <LoginCheck>
            <ClientApplication route={routes} />
        </LoginCheck>
    );
};

export default CredentialChecker;
